// โมเดลที่รันในเบราว์เซอร์ (WebLLM prebuilt) — ใช้ตัวเดียว (Qwen2.5-0.5B) ตามที่ผู้ใช้ตัดสินใจ ; โครงเป็นรายการเผื่อเพิ่มภายหลัง + ค่าที่ผู้ใช้เลือก/ยอมรับดาวน์โหลด (เก็บใน localStorage)
//  downloadMB = ขนาดไฟล์น้ำหนักรวมตาม ndarray-cache.json ของโมเดลบน HuggingFace ; vramMB = vram_required_MB ใน prebuiltAppConfig ของ @mlc-ai/web-llm@0.2.86
export const LLM_MODELS = [
  { id: "Qwen2.5-0.5B-Instruct-q4f16_1-MLC", name: "Qwen2.5 0.5B", tier: "เบา โหลดเร็ว", downloadMB: 278, vramMB: 945 },
];
export const DEFAULT_LLM_ID = LLM_MODELS[0].id;

export const llmById = (id) => LLM_MODELS.find((m) => m.id === id) || LLM_MODELS[0];

const KEY = "aitalk:llm";
const read = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "{}");
    return v && typeof v === "object" ? v : {};
  } catch (e) {
    return {};
  }
};
const write = (v) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(v));
  } catch (e) {
    /* พื้นที่เก็บเต็ม/ปิดไว้ — ข้ามได้ */
  }
};

export const getSelectedLlm = () => llmById(read().modelId).id;
export const setSelectedLlm = (id) => write({ ...read(), modelId: llmById(id).id });
/** ผู้ใช้เคยยอมรับดาวน์โหลด (และโหลดสำเร็จ) โมเดลนี้แล้ว */
export const hasLlmConsent = (id) => !!(read().consent || {})[id];
export const setLlmConsent = (id, v = true) => {
  const cur = read();
  write({ ...cur, consent: { ...(cur.consent || {}), [id]: !!v } });
};
export const fmtMB = (mb) => (mb >= 1000 ? (mb / 1000).toFixed(1) + " GB" : Math.round(mb) + " MB");
